module.exports = __webpack_public_path__ + "img/Config-icon-testPage.c224e11d.svg";